import { render, staticRenderFns } from "./CreateDashboardItem.vue?vue&type=template&id=7a0cbfa0"
import script from "./CreateDashboardItem.vue?vue&type=script&lang=ts"
export * from "./CreateDashboardItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a0cbfa0')) {
      api.createRecord('7a0cbfa0', component.options)
    } else {
      api.reload('7a0cbfa0', component.options)
    }
    module.hot.accept("./CreateDashboardItem.vue?vue&type=template&id=7a0cbfa0", function () {
      api.rerender('7a0cbfa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/CreateDashboardItem.vue"
export default component.exports